import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import MobileVersion from "../components/mobileVersion/MobileVersion";
import useWindowSize from "../hooks/useWindowSize";
import classes from "./AddCustomer.module.scss";
import { JsonEditor as Editor } from "jsoneditor-react";
import { Container, Row, Col, OverlayTrigger, Tooltip, Collapse } from "react-bootstrap";
import LoadingDots from "../components/UI/LoadingDots";
import Button from "../components/UI/Button";
import AddCustomerDetails from "../components/addCustomerElements/AddCustomerDetails";
import { OrgIdContext, CustomerRelations, ClientTypes } from "../store/orgId_context";
import JSONPretty from "../components/jsonPrettyOverride/JSONPretty";
import UserId from "../components/addCustomerElements/UserId";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useQuery } from '@tanstack/react-query'
import { DDD, E2Data, tx } from "../lib/ddd/ddd";
import ButtonLink from "../components/UI/ButtonLink";
import GenericModal from "../components/UI/GenericModal";
import UsersIds from "../components/addCustomerElements/UsersIds";
import { GenericTooltip } from "../components/integrationWizard/form/GenericTooltip";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Alert, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ApiIcon from '@mui/icons-material/Api';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { NavLink } from "react-router-dom";
import FileUploader from "../components/profileComponents/fields/FileUploader";
import FileUploadInput from "../components/addCustomerElements/FileUploadInput";
import PersonIcon from '@mui/icons-material/Person';
import AddCustomerRequest from "../components/addCustomerElements/AddCustomerRequests";
import AddCustomerResponse from "../components/addCustomerElements/AddCustomerResponse";
import UsersTable from "../components/addUserComponents/UsersTable";


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);
const e2Data = new E2Data("EU_CompanyAdminObject");

const objData = {
    "DDDI_AddMyUser" : [
        {
            FieldName : "Name",
            Type : "text",
            Mandatory : true
        },
        {
            FieldName : "LastName",
            Type : "text",
            Mandatory : true
        },
        {
            FieldName : "Email",
            Type : "text",
            Mandatory : true
        },
        {
            FieldName : "Country",
            Type : "text",
            Mandatory : false
        },
        {
            FieldName : "Role",
            Type : "text",
            Mandatory : false,
            Options : [null, "trustee"]
        },
        {
            FieldName : "Culture",
            Type : "text",
            Mandatory : false,
        },
        {
            FieldName : "MobilePhoneNu",
            Type : "text",
            Mandatory : false,
        },
    ],
    "DDDI_RemoveMyUser" : [
        {
            FieldName : "Id",
            Type : "text",
            Mandatory : true,
        },
    ],
}
const IntegrationAddUser = () => {
    const { width } = useWindowSize();
    const { connectionKey, integrationDevice, setConnKeyHandler, mainOrgId, sessionInfo, customerRelation, clientType } = useContext(OrgIdContext);
    const [selectedApi, setSelectedApi] =  useState("DDDI_GetMyUsers");
    const [editorObject, setEditorObject] = useState(null);
    const [rows, setRows] = useState();
    const [error, setError] = useState();
    const [currentCurl, setCurrentCurl] = useState(null);
    const [currentJsonrpc, setCurrentJsonrpc] = useState(null);
    const [currentFetch, setCurrentFetch] = useState(null);

    const [response, setResponse] = useState(null);
    const [isResLoading, setIsResLoading] = useState(null);

    const [isLoading, setIsLoading] = useState(true);
    const [usersList, setUsersList] = useState(null);
    const [tableError, setTableError] = useState();

    const onApiSelectChange = (e) => {
        setSelectedApi(e.target.value);
    }
    
    useEffect(() => {
        setError(null);
        setResponse(null);
        if(selectedApi === "DDDI_GetMyUsers") return GenerateGetUsers();

        let rows = objData[selectedApi];
        if(!rows)
            return setError("Unable to load data");
        setRows(rows);
        const emptyObj = {};
        
        rows.forEach(item => {
            if(item.FieldName){
                emptyObj[item.FieldName] = item.Type==="boolean" ? false : null;
            }
        });

        setEditorObject(emptyObj);
        setCallExamples(emptyObj);
    }, [selectedApi]);

    useEffect(()=>{
        refreshUsers();
    }, []);

    const refreshUsers = () =>{
        const req = DDD.WithConnectionKey(apiRequestAddress, integrationDevice);
        setIsLoading(true);
        req.Rpc_ExecuteExtension("EUeInvoices.DDDI_GetMyUsers",  {}).then(res =>{
            setUsersList(res?.result?.Result);
            setIsLoading(false);
        });
    }

    const _setTableError = (err) =>{
        if(!err) return setTableError(err);
        setTableError(err);
        setTimeout(() => {setTableError(null);}, 5000);
    }
    const GenerateGetUsers = () => {
        setCallExamples({});
    }
    const setCallExamples = (object) => {
          const curlCmd = tx(`curl -X POST https://${
            window.location.hostname
          }/api/service/EUeInvoices.${selectedApi} -H "Authorization: IoT ${integrationDevice}:EUeInvoices" -H "Content-Type: application/json" -d ${JSON.stringify(
            JSON.stringify(object)
          )}`);
    
          const requestBody = tx(`RpcClient.headers['Authorization'] = 'IoT ${integrationDevice}:EUeInvoices'
          RpcClient.call("Extension.Execute", { extension: "EUeInvoices.${selectedApi}", args: ${JSON.stringify(
            object
          )} }).done(res => {}).post()`);
    
          const fetchBody = `fetch(endpoint, {
            method: "POST",
            credentials: "omit",
            headers: {
              "Content-Type": "application/json",
              Authorization: "IoT ${integrationDevice}:EUeInvoices",
              "D3Pro-PreferAuthorizationOverSession": "True",
            },
            body: ${JSON.stringify(object)},
          })
            .then((response) => {})
            .catch((error) => {});`;
    
          setCurrentCurl(curlCmd);
          setCurrentJsonrpc(requestBody);
          setCurrentFetch(fetchBody);
    }

    const isDisabled = (fieldName) => {
        return false;
    }

    const onUploadValueChange = (fieldName, value) =>{
      updateValueByKey(fieldName, value);
    }
    const handleFieldChange = (fieldName, value) => updateValueByKey(fieldName, value);
    const updateValueByKey = (key, newValue) => {
        for (let prop in editorObject) {
          if (prop === key) {
            setEditorObject((prevEditorObject) => ({
              ...prevEditorObject,
              [key]: newValue,
            }));
            
            //renderFormField(key);
          }
        }
    };
    const getValueForFieldName = (fieldName) => {
        if(editorObject.hasOwnProperty(fieldName))
          return editorObject[fieldName];
    }

    const renderFormField = (fieldName, style) => {
        const info = getFieldInfo(fieldName);
        if(fieldName === "CompanyLogo" || fieldName === "CompanyStamp" || fieldName==="DocSignScan")
          info.Type = "file";
        switch(info?.Type){
            case "date":
                return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <input
                        type="date"
                        defaultValue=""
                        disabled = {isDisabled(fieldName)}
                        value={getValueForFieldName(fieldName)}
                        style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
                        onChange={(e) => handleFieldChange(fieldName, e.target.value)}
                      />
                    </div>
                  );
            case "datetime":
                return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <input
                        type="datetime-local"
                        defaultValue=""
                        step={1}
                        disabled = {isDisabled(fieldName)}
                        value={getValueForFieldName(fieldName)}
                        style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
                        onChange={(e) => handleFieldChange(fieldName, e.target.value)}
                      />
                    </div>
                  );
            case "decimal":
            case "integer":
                return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <input
                        type="number"
                        defaultValue=""
                        disabled = {isDisabled(fieldName)}
                        value={getValueForFieldName(fieldName)}
                        style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
                        onChange={(e) => handleFieldChange(fieldName, e.target.value.length > 0 ? parseFloat(e.target.value) : null)}
                      />
                    </div>
                  );
            case "boolean":
                return (
                    <div key={fieldName} className="w-100" style={style}>
                        <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                        <select
                            onChange={(e) => handleFieldChange(fieldName, e.target.value==="true" ? true : false)}
                            value={getValueForFieldName(fieldName)}
                            disabled = {isDisabled(fieldName)}
                        >
                            <option value={true} key="true">True</option>
                            <option value={false} key="false">False</option>
                        </select>
                    </div>
                  );
            case "file":
              return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <FileUploadInput fieldName={fieldName} onValueChange={onUploadValueChange}/>
                    </div>
                );
            default:
                return (
                    <div key={fieldName} className="w-100" style={style}>
                      <label style={{textWrap:"nowrap"}}>{fieldName}{isMandatory(fieldName) && "*"}{getTooltip(fieldName)}{getError(fieldName)}</label>
                      <input
                        type="text"
                        defaultValue=""
                        disabled = {isDisabled(fieldName)}
                        value={getValueForFieldName(fieldName)}
                        style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
                        onChange={(e) => handleFieldChange(fieldName, e.target.value.length > 0 ? e.target.value : null)}
                      />
                    </div>
                  );
        }
    }

    const getTooltip = (fieldName) =>{
        const info = getFieldInfo(fieldName);
        if(!info)
          return;
        const tooltip = info.Description;
        if(!tooltip)
          return;
        return (
          <OverlayTrigger placement="left" overlay={<Tooltip>{tooltip}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
          </OverlayTrigger>
        )
    }
    const getError = (fieldName) =>{return null;}
    const isMandatory = (fieldName) => {
        const info = getFieldInfo(fieldName);
        if(!info) return false;
        return info.Mandatory;
    }
    const getFieldInfo = (fieldName) =>{
        return rows.find(item => item.NameInObject === fieldName || item.FieldName === fieldName);
    }
    
    const onSubmitCall = () => {
        const req = DDD.WithConnectionKey(apiRequestAddress, integrationDevice);
        setIsResLoading(true);
        req.Rpc_ExecuteExtension("EUeInvoices."+selectedApi, selectedApi==="DDDI_GetMyUsers" ? {} : editorObject).then(res =>{
            setResponse(res?.result);
            setIsResLoading(false);
        });
    }
    const removeUser = (id) => {
        if(!id) return;
        const req = DDD.WithConnectionKey(apiRequestAddress, integrationDevice);
        req.Rpc_ExecuteExtension("EUeInvoices.DDDI_RemoveMyUser",  {Id: id}).then(res =>{
            if(res?.result?.Status === "Error")
                return _setTableError(res?.result?.Reason || "Unknown error occured. Please contact administrator");
            refreshUsers();
        });
    }



    return (<>
        <Helmet>
            <title>User management | DDD Invoices</title>
        </Helmet>
{width > 768 && (
        <div className={`w-100 d-flex flex-column p-5 ${classes.container}`}>
            <div className={classes["blankTitle"]}><PersonIcon/>User management</div>
            <div className={`${classes["container-panel"]}`} style={{height:"auto"}}>
                To create, edit or remove users, for yourself or your customer, you can use the following APIs
                <ul>
                    <li>{tx("EUeInvoices.DDDI_GetMyUsers")}</li>
                    <li>{tx("EUeInvoices.DDDI_AddMyUser")}</li>
                    <li>{tx("EUeInvoices.DDDI_RemoveMyUser")}</li>
                </ul>
                By using your <u>integration key</u> ({integrationDevice}), you can manipulate data as you wish as the users you are creating/deleting
                are not real users. Once you start using your connection key, the users you create will recieve an email to complete their user creation process.
            </div>
            <div className={classes["blankTitle"]}><PersonIcon/>Test data</div>
            <div className={`${classes["container-panel"]}`} style={{height:"auto"}}>
                <p>
                    Below is a table of your test users. Using your <u>integration key</u> or in the table below, you can add and remove new users as you wish, since
                    you're operating with dummy data.
                </p>
                {tableError && <>
                    <Alert severity="warning">
                        {tableError}
                    </Alert>
                </>}
                {usersList && <UsersTable usersData={usersList}  loading={isLoading} removeUser={removeUser} testMode={true} refreshUsers={refreshUsers}/>}
            </div>
            <div className={classes["blankTitle"]}>
                <div style={{marginBottom:"1rem"}}><ApiIcon/>Select API:</div>
                <FormControl fullWidth>
                    <InputLabel id="api-select">API</InputLabel>
                    <Select
                        labelId="api-select"
                        id="demo-simple-select"
                        value={selectedApi}
                        label="Age"
                        sx={{backgroundColor:"white"}}
                        onChange={onApiSelectChange}
                    >
                        <MenuItem value={"DDDI_GetMyUsers"}>{tx("DDDI_GetMyUsers")}</MenuItem>
                        <MenuItem value={"DDDI_AddMyUser"}>{tx("DDDI_AddMyUser")}</MenuItem>
                        <MenuItem value={"DDDI_RemoveMyUser"}>{tx("DDDI_RemoveMyUser")}</MenuItem>
                    </Select>
                </FormControl>
                {error && <>
                    <Alert severity="warning">
                        {error}
                    </Alert>
                </>}
            </div>
            <div className={`${classes["container-panel"]}`} style={{height:"auto"}}>
                {selectedApi !== "DDDI_GetMyUsers" && <Row>
                    <Col className="col-6 pe-3">
                        <Row style={{justifyContent:"center"}}>Edit</Row>
                        <div className={classes["form-wrapper"]} style={{maxHeight:"75vh",minHeight:"25vh"}}>
                        <form>
                          {editorObject &&
                            Object.entries(editorObject).map(
                              ([fieldName, fieldConfig]) =>{
                                  if(fieldName==="CustomerObj") return;
                                  return renderFormField(fieldName)
                                }
                            )}
                        </form>
                      </div>
                      </Col>
                    <Col className="col-6 pe-3">
                    <Container className="d-flex flex-column h-100">
                        <Row style={{justifyContent:"center"}}>Upload object preview</Row>
                        <Row style={{ flex: 1 }}>
                          <Col
                            className="d-flex p-0"
                            // style={{ maxHeight: "calc(66vh - 64px)" }}
                          >
                            <div className={classes["new-invoice-response"]}>
                              <div className={classes["editor-wrapper"]}>
                                <JSONPretty data={editorObject}/>
                              </div>
                            </div>
                          </Col>
                        </Row>
                    </Container>
                    </Col>
                </Row>}
                <Row className="mt-3">
                    <Col className="col-6 pe-3">
                      <AddCustomerRequest
                        currentCurl={currentCurl}
                        currentJson={currentJsonrpc}
                        currentFetch={currentFetch}
                      />
                    </Col>
                    <Col className="col-6 p-0">
                      <div className="text-center">
                        <Button onClick={onSubmitCall} className="px-3">
                          Submit
                        </Button>
                      </div>
                      <AddCustomerResponse
                        response={response}
                        isLoading={isResLoading}
                      />
                    </Col>
                </Row>
            </div>
        </div>
)}
{width <= 768 && <MobileVersion />}
    </>)
}
export default IntegrationAddUser;